import moment from 'moment';
import getItemStyles from '../../../utils/item-styles';

const _ = require('lodash');

const generateIndicators = (rId, dayType, tourStartTime, indicatorId) => {
    let title;
    let itemStyle = getItemStyles('indicators');
    const { rdtId, tour } = dayType;

    // liveSchedule = dayType.remoteIndicator || postedSchedule = dayType.tour.remoteIndicator
    const remoteIndicator = dayType.remoteIndicator || dayType.tour.remoteIndicator;

    let tourIndicatorsWithRemote = _.cloneDeep(tour.tourIndicators) || [];

    // insert remote indicator at the front of indicator array if it exists
    if (remoteIndicator) {
        tourIndicatorsWithRemote.unshift({
            name: "Remote Location"
        });
    }

    const indicatorTitleArray = tourIndicatorsWithRemote.map((indicator) => {
        if (!indicator.code || (indicator.name === indicator.code)) {
            return indicator.name;
        } else {
            return `${tourIndicatorsWithRemote[0].name} / ${tourIndicatorsWithRemote[0].code}`;
        }
    })

    // determine the title for the indicator item within the timeline
    if (indicatorTitleArray.length === 1) {
        title = indicatorTitleArray[0];
    } else if (indicatorTitleArray.length > 1) {
        title = `${indicatorTitleArray[0].slice(0, 7)} (...)`;
    }

    const indicatorItem = {
        id: `indicator-${tour.tourId}`,
        rdtId,
        itemType: 'indicators',
        start_time: moment(tourStartTime).startOf('day'),
        end_time: moment(tourStartTime).endOf('day'),
        title,
        group: rId,
        backgroundColor: tour.isApproved ? "gray" : itemStyle.backgroundColor,
        color: itemStyle.color,
        borderStyle: itemStyle.borderStyle,
        borderColor: itemStyle.borderColor
    };

    return indicatorItem;
}

export default generateIndicators;



// WEBPACK FOOTER //
// ./src/Components/Schedule/SevenNineDay/utils/generate-timeline/generateIndicators.js